import reducer from "./reducer";
export { default as functionsSettings } from "./components/index";
export { default as functionsSettingsReducerName } from "./constants";
export default reducer;
